/** 型引数Tにおける値部分のユニオンを返します */
export type ValueOf<T> = T[keyof T];

/**
 * Object型から任意の型のフィールドのみを抽出するユーティリティタイプ
 * https://zenn.dev/yuta_takahashi/articles/a009f3259d0b87
 */
export type PickByType<
  T extends Record<string, unknown>,
  PickedType = unknown,
> = Pick<
  T,
  {
    [K in keyof T]: T[K] extends PickedType ? K : never;
  }[keyof T]
>;

/**
 * 厳格に型定義されたObject.entries()
 * @param object
 * @returns object
 */
export const strictEntries = <T extends Record<string, unknown>>(
  object: T
): [keyof T, T[keyof T]][] => {
  return Object.entries(object) as [keyof T, T[keyof T]][];
};

/**
 * 値が型付けされた配列に含まれているかチェックする
 * @param value
 * @param array
 * @returns
 */
export const checkIsUnknownItemInArray = <T>(
  value: unknown,
  array: readonly T[]
): value is T => array.some((item) => item === value);

/**
 * 型をオーバーライドする
 * Modify<{a:string, b:string}, {a:number}>
 */
export type Modify<T, R> = Omit<T, keyof R> & R;

/**
 * 型定義されたObject.keys()
 * @param object
 * @param obj
 * @returns
 */
export const strictObjectKeys = <T extends Record<string | number, unknown>>(
  obj: T
): (keyof T)[] => {
  return Object.keys(obj);
};
